// extracted by mini-css-extract-plugin
export default {"page_header":"styles_page_header__nGReH"};